import { colors } from "@theme/colors"

const CruiseIcon = ({ color = colors.iconPrimary, height = 18, width = 18 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5479 3.31103L11.4342 2.28471H14.8816V3.31103H10.5479ZM8.51376 3.31103L10.4226 1.10073C10.6176 0.874997 10.9011 0.745239 11.1994 0.745239H15.3947C15.9616 0.745239 16.4211 1.20474 16.4211 1.77156V3.31103V4.8505V5.87682V7.41629V13.4558C16.4211 13.8046 16.1383 14.0873 15.7895 14.0873H7.97139C3.56891 14.0873 0 10.5184 0 6.11596C0 5.98389 0.107067 5.87682 0.239142 5.87682H3.52213L5.66806 3.6287C5.86172 3.42582 6.12998 3.31103 6.41045 3.31103H8.51376ZM14.8816 4.8505H7.18421H6.63003L5.65037 5.87682H14.8816V4.8505ZM2.05263 7.41629L14.8816 7.41629V12.5479H7.97139C4.86461 12.5479 2.2723 10.3452 1.67098 7.41629L2.05263 7.41629Z"
        fill={color}
      />
    </svg>
  )
}

export default CruiseIcon
